<template>

  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">货运柜子费用</div>
      
    
      <el-form-item label="拼柜费用/立方">
        <el-input v-model="form.fcl_price" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="整柜费用/立方">
        <el-input v-model="form.lcl_price" class="max-w460"></el-input> 
      </el-form-item>

  
      <!--提交-->
      <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>


  </div>

</template>

<script>
  import SettingApi from '@/api/setting.js';

  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          fcl_price: '',
          lcl_price: ''
        },
        w7:{},
        loading: false,
        ws: null,         // WebSocket实例
      reconnectAttempt: 0, // 重连次数
      maxReconnect: 5,    // 最大重连次数
      };
    },
    created() {
      this.getData()
      this.initWebSocket();
    },
    beforeDestroy() {
    // 组件销毁时关闭连接
    if (this.ws) {
      this.ws.close();
    }
  },

    methods: {
      clickGet(){
        var self = this;
       
      },
      getData() {
        let self = this;
       SettingApi.getsupply({}).then(res =>{
        let vars = res.data.vars.values
        let lcl_price = vars.lcl_price
        let fcl_price = vars.fcl_price
        self.form.lcl_price = lcl_price
        self.form.fcl_price = fcl_price
       })

      },


      //提交表单
      onSubmit() {
        let self = this;
        self.loading = true;
        var params = this.form
        SettingApi.supply(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，设置成功',
              type: 'success'
            });

          })
          .catch(error => {
            self.loading = false;
          });
      },
      //发送短信
     
      initWebSocket() {
      const wsUrl = process.env.NODE_ENV === 'production' 
        ? 'wss://your-domain.com/ws/setting'
        : 'ws://hxing.1.y01.cn:8282';

      this.ws = new WebSocket(wsUrl);

      // 连接成功回调
      this.ws.onopen = () => {
        console.log('WebSocket连接已建立');
        this.reconnectAttempt = 0; // 重置重连计数器
        
        // 发送身份认证（如果需要）
        this.sendWsMessage({
          type: 'auth',
          token: 'your-auth-token'
        });
      };

      // 接收消息处理
      this.ws.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          this.handleWsMessage(message);
        } catch (error) {
          console.error('消息解析失败:', error);
        }
      };

      // 错误处理
      this.ws.onerror = (error) => {
        console.error('WebSocket错误:', error);
      };

      // 连接关闭处理
      this.ws.onclose = (event) => {
        if (event.wasClean) {
          console.log(`连接正常关闭 Code=${event.code} Reason=${event.reason}`);
        } else {
          console.error('连接意外断开');
          this.handleReconnect();
        }
      };
    },

    // 处理WebSocket消息
    handleWsMessage(message) {
      switch(message.type) {
        case 'priceUpdate':
          console.log('收到价格更新:', message.data);
          this.form.fcl_price = message.data.fcl_price;
          this.form.lcl_price = message.data.lcl_price;
          break;
        case 'system':
          this.$message({
            message: message.content,
            type: 'info'
          });
          break;
        default:
          console.warn('未知消息类型:', message.type);
      }
    },

    // 发送WebSocket消息
    sendWsMessage(payload) {
      if (this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify({
          timestamp: Date.now(),
          ...payload
        }));
      } else {
        console.warn('WebSocket未就绪，消息未发送');
      }
    },

    // 处理重连逻辑
    handleReconnect() {
      if (this.reconnectAttempt < this.maxReconnect) {
        const delay = Math.pow(2, this.reconnectAttempt) * 1000;
        
        setTimeout(() => {
          console.log(`尝试第${this.reconnectAttempt + 1}次重连...`);
          this.initWebSocket();
          this.reconnectAttempt++;
        }, delay);
      } else {
        console.error('已达最大重连次数，放弃连接');
      }
    },

    // 修改后的提交方法
    onSubmit() {
      const self = this;
      self.loading = true;
      
      const mid = 'm' + Math.random().toString(36).substring(2);

      // 同时发送API请求和WebSocket通知
      Promise.all([
        SettingApi.supply(this.form, true),
        this.sendWsMessage({
          user_id: 1,
        type: 'chat',
        msgtype: 'system_tip',
        content: "拼柜价格为"+this.form.fcl_price+"整柜价格为"+this.form.lcl_price,
        mid: mid,
        to_user_id:0,
        obj: JSON.stringify({ type: 1})
        })
      ]).then(() => {
        self.$message({
          message: '设置成功',
          type: 'success'
        });
      }).catch(error => {
        console.error('提交失败:', error);
      }).finally(() => {
        self.loading = false;
      });
    }


    }

  };
</script>

<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/setting/supply/index.vue